module.exports = __webpack_public_path__ + "08_mole.275ed35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/08_mole.png
// module id = AtD4
// module chunks = 0